import { Eye, Loader2, RefreshCw } from 'lucide-react'
import { useListObserversQuery } from '@axilon-apps/domains-ontology-ui-state'

import { Badge } from '../../../components/ui/badge'
import { Button } from '../../../components/ui/button'
import { Card, CardContent } from '../../../components/ui/card'

export function ObserversTab() {
  const query = useListObserversQuery()
  const observers = [...(query.data ?? [])].sort((a, b) => a.name.localeCompare(b.name))

  return (
    <Card className="gap-3 py-4">
      <CardContent className="flex flex-col gap-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex flex-col gap-0.5">
            <h3 className="text-sm font-semibold text-ink">Observers</h3>
            <p className="text-xs text-ink-3">
              Read-only registry projections that can report sightings about plant entities.
            </p>
          </div>
          <Button
            size="xs"
            variant="outline"
            onClick={() => void query.refetch()}
            disabled={query.isFetching}
          >
            <RefreshCw className={query.isFetching ? 'animate-spin' : undefined} />
            Refresh
          </Button>
        </div>

        {query.isLoading ? (
          <div className="flex items-center gap-2 py-2.5 text-xs text-ink-3">
            <Loader2 className="size-3 animate-spin" />
            Loading observers…
          </div>
        ) : null}

        {query.isError ? (
          <div role="alert" className="rounded-md bg-st-down-bg px-3 py-2 text-xs text-st-down">
            Failed to load observers.
          </div>
        ) : null}

        {!query.isLoading && !query.isError && observers.length === 0 ? (
          <p className="py-2.5 text-xs text-ink-3">
            No observers have been provisioned for this organization.
          </p>
        ) : null}

        {observers.length > 0 ? (
          <ul className="flex flex-col">
            {observers.map((observer) => {
              const id = observer.id
              const name = observer.name || id
              const kind = observer.kind
              const status = observer.status
              return (
                <li
                  key={id}
                  className="flex items-center gap-3 border-b border-line py-2.5 last:border-b-0"
                >
                  <Eye className="size-4 shrink-0 text-ink-3" aria-hidden="true" />
                  <div className="flex min-w-0 flex-1 flex-col">
                    <span className="truncate text-sm font-medium text-ink">{name}</span>
                    <span className="truncate font-mono text-11 text-ink-3" title={id}>
                      {id}
                    </span>
                  </div>
                  <Badge variant="outline" className="shrink-0 capitalize">
                    {kind}
                  </Badge>
                  {status ? (
                    <Badge variant="secondary" className="shrink-0 capitalize">
                      {status}
                    </Badge>
                  ) : null}
                </li>
              )
            })}
          </ul>
        ) : null}
      </CardContent>
    </Card>
  )
}
